import meter1 from "../assets/img/meter1.svg";
import meter2 from "../assets/img/meter2.svg";
import meter3 from "../assets/img/meter3.svg";
import Carousel from "react-multi-carousel";
import Link from '@mui/material/Link';
import "react-multi-carousel/lib/styles.css";
import arrow1 from "../assets/img/arrow1.svg";
import arrow2 from "../assets/img/arrow2.svg";
// import colorSharp from "../assets/img/color-sharp.png";
import uploadButton from "./uploadButton";
import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import { storage } from "../firebase";
import { ref, uploadBytes, listAll, getDownloadURL } from "firebase/storage";
import { v4 } from "uuid";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import ProductCard from "./product/ProductCard";
import axios from "axios";
import { styled } from '@mui/material/styles';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Collapse from '@mui/material/Collapse';
import Avatar from '@mui/material/Avatar';
import IconButton, { IconButtonProps } from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { red } from '@mui/material/colors';
import FavoriteIcon from '@mui/icons-material/Favorite';
import ShareIcon from '@mui/icons-material/Share';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Rating from '@material-ui/lab/Rating';
// import EbayItemsWidget from 'ebay-items-react-widget';

export const Skills = () => {
  const [file, setFile] = useState(null);
  const [hideForm, setHideForm] = useState(false);
  const [hideSearch, setHideSearch] = useState(true);
  const [hideAmz, setHideAmz] = useState(true);
  const [searchTerm, setSearchTerm] = useState(null);
  const [searchTerm2, setSearchTerm2] = useState(null);
  const [image, setImage] = useState('');
  const [path, setPath] = useState("");
  const [fileName, setFileName] = useState("");
  const [UPCState,setUPCState] =  useState("");
  const [UPCObject, setUPCObject] = useState(null);
  const [amazonObject,setAmazonObject] = useState(null);
  const [errMessage,setErrMessage] = useState('');
  const [goog,setGoog] = useState([]);
  const [amzn,setAmzn] = useState([]);
  const [productArray,setProductArray] = useState([]);

  const clickLog = () =>{
    console.log(amazonObject)
   
  }

  const getGoogle = async (itemName) => {
    console.log("I AM IN GOOOOOOOGLE")
    let response = await fetch(
        "https://cors-anywhere.herokuapp.com/https://serpapi.com/search.json?engine=google_shopping&q="+ itemName.replace(/\s+/g, '+') +"&location=Montreal,+Quebec,+Canada&hl=en&gl=ca&api_key=8c7ff830425c3940bfdf8b199c382197c194f1aefea9de8f761d86b697e74022",
        {
          method: "get",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );
    const data = await response.json();
    console.log([[data.shopping_results[0].title, data.shopping_results[0].price, data.shopping_results[0].link, data.shopping_results[0].thumbnail], [data.shopping_results[1].title, data.shopping_results[1].price, data.shopping_results[1].link, data.shopping_results[1].thumbnail]])

    setGoog([[data.shopping_results[0].title, data.shopping_results[0].price, data.shopping_results[0].link, data.shopping_results[0].thumbnail], [data.shopping_results[1].title, data.shopping_results[1].price, data.shopping_results[1].link, data.shopping_results[1].thumbnail],[data.shopping_results[2].title, data.shopping_results[2].price, data.shopping_results[2].link, data.shopping_results[2].thumbnail]])

    return [[data.shopping_results[0].title, data.shopping_results[0].price, data.shopping_results[0].link, data.shopping_results[0].thumbnail], [data.shopping_results[1].title, data.shopping_results[1].price, data.shopping_results[1].link, data.shopping_results[1].thumbnail],[data.shopping_results[2].title, data.shopping_results[2].price, data.shopping_results[2].link, data.shopping_results[2].thumbnail]]
  }
  
  const getNamefromImage = async (url) => {
  let body = JSON.stringify({
    requests: [
      {
        image: {
          source: {
            imageUri: url,
          },
        },
        features: [{ type: "TEXT_DETECTION", maxResults: "5" }],
      },
    ],
  });
  
  let response = await fetch(
    "https://vision.googleapis.com/v1/images:annotate?key=AIzaSyCqI7jKNRC41AviYB9RLpHL-O7bCGDuWMA",
    {
      method: "post",
      body: body,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    }
  );
  
  const data = await response.json();
  console.log(data);
  console.log(data.responses[0].fullTextAnnotation.text.replace(/\n/g, '').substring(0,25));

  setSearchTerm2(data.responses[0].fullTextAnnotation.text.replace(/\n/g, '').substring(0,25))
  return data.responses[0].fullTextAnnotation.text.replace(/\n/g, '').substring(0,25);
  };

  
  
    const getAmazon = (itemName) => {
      // make the http GET request to Rainforest API
  
      console.log("IN DA AMAZON")
      console.log(itemName)
      const params = {
        api_key: "AD0FA9FEA0864A39BAAA724CDE85603A",
          type: "search",
          search_term: itemName,
          amazon_domain: "amazon.com",
          language: "en_US",
          currency: "cad",
          customer_location: "ca",
          associate_id: "markrd-20"
        }
        
        // make the http GET request to Rainforest API
        axios.get('https://api.rainforestapi.com/request', { params })
        .then(response => {
        
            // print the JSON response from Rainforest API
            // console.log(response.data);
            console.log("AMAZON RESULTS")
            console.log([[response.data.search_results[0].title, response.data.search_results[0].price.name, response.data.search_results[0].link, response.data.search_results[0].image]])


            setAmzn([[response.data.search_results[0].title, response.data.search_results[0].price.name, response.data.search_results[0].link, response.data.search_results[0].image]])
            return [[response.data.search_results[0].title, response.data.search_results[0].price.name, response.data.search_results[0].link, response.data.search_results[0].image]]
          }).catch(error => {
        // catch and print the error
        console.log(error);
        })
    };
  

  const searchUPCHandler  = () =>{
  
    console.log(searchTerm)
  //   setTimeout(function() {
  //     setProductArray(getAmazon(searchTerm));
  // }, 1000);
    
  setTimeout(function() {
    getGoogle(searchTerm).then((res)=>{
      setProductArray(res)
    })
  
}, 2000);
    
    
    
 
    console.log("======================")
    const combined=goog.concat(amzn)
    console.log(combined)

    

    setHideSearch(true)
    setHideAmz(false)
    
  }

  const searchLabelHandler  = () =>{
  
    console.log("SERACH TEAMER @# N@2 2 2 2 2 2")
    console.log(searchTerm2)
  //   setTimeout(function() {
  //     setProductArray(getAmazon(searchTerm));
  // }, 1000);
    
  setTimeout(function() {
    getGoogle(searchTerm2).then((res)=>{
      setProductArray(res)
    })
  
}, 2000);
    
    
  

    

    setHideSearch(true)
    setHideAmz(false)
    
  }

  const cancelHandler = () =>{
    setHideForm(false)
    setHideSearch(true)
    setHideAmz(true)
    setProductArray([])
    console.log(hideForm)
  }
  const fileHandler = (event) => {
    setFile(event.target.files[0]);
    console.log(event.target.files);
    setFileName(event.target.files[0].name);
  };
  const uploadHandler = (event) => {
    if (file == null) {
      return;
    }
    setErrMessage('')
    setLoading(true);
    setHideForm(true)
    setHideSearch(false)
    setHideAmz(true)

    const imageRef = ref(storage, `images/${file.name + v4()}`);
    setImage(imageRef)
    // setPath(`gs://mchacks-de42d.appspot.com/images/${file.name + v4()}`)
    uploadBytes(imageRef, file)
      .then(() => {
        alert("Image Processed");
        console.log(imageRef);
      })
      .then(() => {
        getDownloadURL(imageRef)
          .then((url) => {
            console.log("URLURLURLURLURL")
            console.log(url);
            setPath(url);
            const NAMERESULT = getNamefromImage(url)
            console.log("NAMENAMENAMEN")
            console.log(NAMERESULT)
            setSearchTerm2(NAMERESULT)
            return getUPCfromImage(url);
          })
          .then((resUPC) => {
            console.log(resUPC);
            setUPCState(resUPC)
            

            const UPCRESULT = getNamefromUPC(resUPC)
            
            setSearchTerm(UPCRESULT)
            return UPCRESULT
            
          }).then((res) => {
            console.log(res)
            setUPCObject(res);
            return res
          })
          // .then( (res) => {
          //   console.log("RESERESRSERESRSERSERESRSERSERESRSERERSERSE")
          //   console.log(res)
          //   console.log(searchTerm)
          //   console.log("RESERESRSERESRSERSERESRSERSERESRSERERSERSE")
          //   getAmazon(res);
    
          //   getGoogle(res)
          // })
          
          
          
          // .then(() => {
          //   console.log("WE IN AMAZON")
           
          //   console.log(searchTerm)
            
          //   // getAmazonfromName(resName)
            
          //   console.log(getAmazon(searchTerm))

          // })
      });

    console.log(imageRef);
  };
  // let image = this.fileToBase64().done();
  const getUPCfromImage = async (url) => {
    let body = JSON.stringify({
      requests: [
        {
          image: {
            source: {
              imageUri: url,
            },
          },
          features: [{ type: "TEXT_DETECTION", maxResults: "5" }],
        },
      ],
    });

    let response = await fetch(
      "https://vision.googleapis.com/v1/images:annotate?key=AIzaSyCqI7jKNRC41AviYB9RLpHL-O7bCGDuWMA",
      {
        method: "post",
        body: body,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );

    const data = await response.json();
    console.log(data);
    console.log(data.responses[0].fullTextAnnotation.text.replace(/\D/g, ""));
    return data.responses[0].fullTextAnnotation.text.replace(/\D/g, "");
  };

  const getNamefromUPC  = (upc) => {
    const api_key =
      "c8ee993c314e72d1aa264415f0059f87beded0b337b418439db71aa6f2ae56ba";

    const api_base_url =
      "https://cors-anywhere.herokuapp.com/https://go-upc.com/api/v1/code/";
    const url = api_base_url + upc;
    const opts = {
      method: "get",
      url: url,
      headers: {
        Authorization: "Bearer " + api_key,
        "Access-Control-Allow-Origin": "*",
      },
    };
    console.log(opts.url);

    axios
      .request(opts)
      .then(function (response) {
        var product_data = response.data;

        console.log(product_data);

        let product_name = product_data.product.name;
        let product_description = product_data.product.description;
        let product_image = product_data.product.imageUrl;

        console.log("Product Name: " + product_name);
        console.log("Product Description: " + product_description);
        console.log("Product Image URL: " + product_image);

        setSearchTerm(product_name)
        
        return product_name;
      })
      .catch(function (error) {
        console.error(error);
        setErrMessage("Go to https://cors-anywhere.herokuapp.com/ and enable demo")
        return -1;
      });
  };



  

  const imageListRef = ref(storage, `images/`);

  const [isLoading, setLoading] = useState(false);

  function simulateNetworkRequest() {
    return new Promise((resolve) => setTimeout(resolve, 2000));
  }

  useEffect(() => {
    if (isLoading) {
      simulateNetworkRequest().then(() => {
        setLoading(false);
      });
    }
  }, [isLoading]);

  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  return (
    <section className="skill">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="skill-bx wow zoomIn">
              <h2 id="swapShop">Swap Your Shop!</h2>

              <p>Try out our Swappr API</p>
              <div id='totalForm'>
              <div id="formS" className={hideForm && 'hidden'}>
                <form>
                  <div id="imageInput">
                    <label htmlFor="inputTag">
                      Select Image <br />
                      <CameraAltIcon className="svg_icons" />
                      <input id="inputTag" type="file" onChange={fileHandler} />
                      <br />
                      <span id="imageName"> {fileName} </span>
                    </label>
                  </div>
                  <Button
                    className=".me-3"
                    variant="secondary"
                    disabled={isLoading}
                    onClick={!isLoading ? uploadHandler : null}
                  >
                    {isLoading ? "Loading…" : "Click to Upload"}
                  </Button>
                </form>
              </div>
              </div>

              <div >
                <div id='Buttons' className={hideSearch && 'hidden'} >
              <Button
                    className={`${hideSearch && 'hidden'} .me-3 topBut`}
                    variant="secondary"
                    disabled={isLoading}
                    onClick={!isLoading ? searchUPCHandler : null}
                  >
                    {isLoading ? "Loading…" : "Search UPC"}
                  </Button>
                  <div id='spacer'></div>
                  <Button
                    className={`${hideSearch && 'hidden'} .me-3 topBut`}
                    variant="secondary"
                    disabled={isLoading}
                    onClick={!isLoading ? searchLabelHandler : null}
                  >
                    {isLoading ? "Loading…" : "Search Label"}
                  </Button>
                  </div>

                  <div className={hideSearch && 'hidden'}>
              <div id='inputsIm'>
                <p className='exPlace'> {UPCState}</p>
                <p className='exPlace'> {searchTerm} </p> 
                <p className='exPlace errorM'> {errMessage} </p> 
                {/* <input placeholder={UPCState} type='text' /> 
                <input placeholder={searchTerm} type='text' />  */}
              
                <img id='uploadedImage'src={path}></img>
              </div>
              <br></br>
              </div>
              <div id='pCARDS' className={hideAmz && 'hidden'} >
                {errMessage}

      <div id='productsC' onClick={clickLog}>


    {
    
    productArray.map( (item) => {
      console.log("!!!!ITEMT!!!!!!")
      console.log(item)
      return (
<Card sx={{ maxWidth: 300,
    marginLeft: 10, }}
    key={item[0]}
    >
      <CardHeader
        avatar={
          <Avatar  aria-label="recipe">
            <CardMedia
        component="img"
        height="194"
        image={require('./amazon-logo.png')}
        alt="Paella dish"
      />
          </Avatar>
        }
        action={
          <IconButton aria-label="settings">
            <MoreVertIcon />
          </IconButton>
        }
        title={item[0]}
        subheader="January 29, 2023"
      />
      {/* <img src={item[3]}> </img> */}
      <CardMedia
        // component="img"
        // height="194"
        sx={{ paddingTop:'50%'}}
        
        square
        image={item[3]}
        
      />
     
      <CardContent>
      <Rating name={'rating'} value={4} size={'small'} />
        <Typography variant="body2" color="text.secondary">
          {item[1]} 
        </Typography>
      </CardContent>
      <CardActions disableSpacing>
        {/* <IconButton aria-label="add to favorites">
          <FavoriteIcon />
        </IconButton> */}
        <IconButton aria-label="share">
        <Link target="_blank" href={item[2]}>
          <ShareIcon />
          </Link>
        </IconButton>

      </CardActions>
      
    </Card>
      )
    })}
    
</div>


              </div>
              <Button
                    className={`${!hideForm && 'hidden'} '.me-3  brutton'`}
                    variant="secondary"
                    disabled={isLoading}
                    onClick={cancelHandler}
                  >
                    { "Cancel"}
                  </Button>
                  
                  </div>
              
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
